exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../styles/page.css"), undefined);

// module
exports.push([module.id, "._7-5zTUz5p8DkHcfUpR6P {\n    padding: 50px 55px;\n    overflow: auto;\n}\n._2OGSymXJucySEUx1IxFUEW {\n    font-size: 2rem;\n    line-height: 1.04;\n}\n._3kqYrwpKxA5td3mDu9UrWh {\n    font-size: 20px;\n    line-height: 1.8;\n}\n._3R52qLbdNSLYVFY9sp88zP {\n    font-size: 16px;\n    line-height: 1.8;\n}\n", ""]);

// exports
exports.locals = {
	"contentWrapper": "_7-5zTUz5p8DkHcfUpR6P " + require("-!../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../styles/page.css").locals["contentWrapper"] + "",
	"accessErrorHeadline": "_2OGSymXJucySEUx1IxFUEW",
	"accessErrorDesc": "_3kqYrwpKxA5td3mDu9UrWh",
	"accessErrorInstr": "_3R52qLbdNSLYVFY9sp88zP"
};


//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/AccessDeniedContent/AccessDeniedContent.css
// module id = 10420
// module chunks = 25